import { render, staticRenderFns } from "./copyabletext.vue?vue&type=template&id=2b4f31aa&lang=pug"
import script from "./copyabletext.vue?vue&type=script&lang=js"
export * from "./copyabletext.vue?vue&type=script&lang=js"
import style0 from "./copyabletext.vue?vue&type=style&index=0&id=2b4f31aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports